
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe14 as ObiHydraulicPipe14Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-14.js';
 
 
 

 
 export const ObiHydraulicPipe14 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-14',
   elementClass: ObiHydraulicPipe14Element,
   events: {
     
   }
  });
 
 